// extracted by mini-css-extract-plugin
module.exports = {"dropdownIcon":"messageModal_dropdownIcon__1AZ3c","dropdownFilesWidth":"messageModal_dropdownFilesWidth__2HyB_"};